<lib-overlayer
  popUpID="dragDropInfoOverlayer"
  [showModal]="showModal"
  [displaySubTitle]="false"
  [options]="options"
  (onClose)="closeModal()"
  [displayFooter]="false"
  [closeButtonHoverTitle]="
    'bills.cover.usageLevel4.tableHeader.reorderColumns.closeOverlayer'
      | translate
  "
>
  <ng-container Title>
    {{
      'bills.cover.usageLevel4.tableHeader.reorderColumns.infoAbout' | translate
    }}
    <br class="show-for-small-only" />{{
      'bills.cover.usageLevel4.tableHeader.reorderColumns.howToUse' | translate
    }}
  </ng-container>
  <ng-container Content>
    <div
      data-cy="odbUsageLevelFourTableHeaderReorderColumnsModal"
      [innerHTML]="
        'bills.cover.usageLevel4.tableHeader.reorderColumns.contentHtml'
          | translate
      "
    ></div>
  </ng-container>
</lib-overlayer>
